
export default {
    name: 'ContentProductsMobile',

    components: {
        MobileProductCard: () => import('~/components/sets-page/MobileProductCard'),
        Pagination: () => import('~/components/UI/Pagination.vue'),
    },

    props: {
        products: {
            type: Array,
            default: () => [],
        },

        pagination: {
            type: Object,
            default: () => ({}),
        },
        totalProducts: {
            type: String,
            default: '',
        },
        totalPages: {
            type: [String, Number],
            default: 0,
        },
    },

    methods: {
        onChangePage(page) {
            window.scrollTo({ top: 0 });
            this.$emit('onChangePage', page);
        },
    },
};
